export const ModalVariant = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
} as const;
export type ModalVariant = (typeof ModalVariant)[keyof typeof ModalVariant];
